var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Card, Col, Row, Select, TextField } from '@folio/stripes/components';
import React, { useMemo } from 'react';
import { Field, useField } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { CriteriaAggregateType } from '../../types';
import css from '../Card.module.css';
import OperatorSelect from './OperatorSelect';
export default function AggregateCriteriaCard() {
    var selectedType = useField('aggregateFilter.type', {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : CriteriaAggregateType.PASS; },
    }).input.value;
    var intl = useIntl();
    var criteriaOptions = useMemo(function () { return __spreadArray([
        {
            label: intl.formatMessage({
                id: 'ui-plugin-bursar-export.bursarExports.aggregate.filter.none',
            }),
            value: CriteriaAggregateType.PASS,
        }
    ], [
        {
            label: intl.formatMessage({
                id: 'ui-plugin-bursar-export.bursarExports.aggregate.filter.numAccounts',
            }),
            value: CriteriaAggregateType.NUM_ROWS,
        },
        {
            label: intl.formatMessage({
                id: 'ui-plugin-bursar-export.bursarExports.aggregate.filter.totalAmount',
            }),
            value: CriteriaAggregateType.TOTAL_AMOUNT,
        },
    ].sort(function (a, b) { return a.label.localeCompare(b.label); }), true); }, [intl]);
    return (React.createElement(Card, { headerStart: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.aggregate.filter.header" }) },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(Field, { name: "aggregateFilter.type", defaultValue: CriteriaAggregateType.PASS }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.aggregate.filter" }), dataOptions: criteriaOptions }))); })),
            selectedType !== CriteriaAggregateType.PASS && (React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(OperatorSelect, { name: "aggregateFilter.operator" }))),
            selectedType === CriteriaAggregateType.NUM_ROWS && (React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(Field, { name: "aggregateFilter.amount" }, function (fieldProps) { return (React.createElement(TextField, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, type: "number", label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.aggregate.filter.numAccounts.amount" }), min: 1, step: 1 }))); }))),
            selectedType === CriteriaAggregateType.TOTAL_AMOUNT && (React.createElement(Col, { xs: 12, md: 4 },
                React.createElement(Field, { name: "aggregateFilter.amountCurrency" }, function (fieldProps) { return (React.createElement(TextField, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, type: "number", label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.aggregate.filter.totalAmount.amount" }), min: 0, step: 0.01 }))); })))),
        React.createElement("p", { className: css.aggregateCardP },
            React.createElement("i", null,
                React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.aggregate.filter.description" })))));
}
